/**
 * Expanded info about a source path, as used in processed route configs.
 */
export interface ExpandedSourcePath {
  /**
   * The relative path to the source file. (e.g. `./src/index.ts`)
   */
  sourcePath: string;

  /**
   * The import map key to be used when importing the bundled output.
   * (e.g. `.` represents the default package export.)
   */
  importPath: string;
}
